import React, { useState, useEffect } from "react";
import { obtenerPrestamosPorEstudiantePaginados } from "../../services/PrestamosService";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import { BiLogIn } from "react-icons/bi";
import { IoMenuSharp, IoSearch, IoCloseCircle, IoClose } from "react-icons/io5";
import logoBarra from "../../assets/LogoUam.png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  useGetWindowDimensions,
  acortarTexto,
  formatearFecha,
} from "../../utils/functions";
import { useUser } from "../../context/userContext";
import BookImage from "../bookImage";
import "./index.css";

function Barra() {
  const navigate = useNavigate();
  const { userData, logoutUser } = useUser();
  const [profileDropDown, setProfileDropDown] = useState(false);
  const [misPrestamosDropDown, setMisPrestamosDropDown] = useState(false);
  const [prestamosData, setPrestamosData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [nav, setNav] = useState(false);
  const [search, setSearch] = useState(false);

  const handleLogOut = async () => {
    try {
      await logoutUser();
      navigate("/");
    } catch (e) {
      console.log(e.message);
    }
  };

  const fetchUserData = async () => {
    if (userData.cif) {
      const prestamosResponse = await obtenerPrestamosPorEstudiantePaginados(
        userData.cif,
        0,
        3,
      );
      setPrestamosData(prestamosResponse.content);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [userData.cif]);

  const handleSearch = async (e) => {
    e.preventDefault();
    navigate(`/resultados-busqueda?query=${searchTerm}`);
  };

  const handleNav = () => {
    setNav(!nav);
  };
  return (
    <div className="barra-containermayor">
      {nav && <div className="dark-overlay"></div>}
      {useGetWindowDimensions().winWidth >= 768 ? (
        <div className="barra-container-limit">
          <nav className="barra-container">
            <Link to="/menuestudiante">
              <img src={logoBarra} alt="logo" className="img-logo" />
            </Link>
            <form className="usuarioBarra-searchContainer" onSubmit={handleSearch}>
              <AiOutlineSearch size={20} style={{ color: "#909090" }} />
              <input
                type="text"
                placeholder="Buscar un libro"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </form>
            <ul className="navBar-list">
              <Link
                className="barra-list-links items-container"
                onMouseEnter={() => setMisPrestamosDropDown(true)}
                onMouseLeave={() => setMisPrestamosDropDown(false)}
              >
                <li>Mis Préstamos</li>
                {misPrestamosDropDown && (
                  <MisPrestamosDropDown prestamosData={prestamosData} />
                )}
              </Link>
              <div
                className="items-container"
                onMouseEnter={() => setProfileDropDown(true)}
                onMouseLeave={() => setProfileDropDown(false)}
              >
                {loading === false ? (
                  <img
                    src={userData.userPic}
                    alt="logo"
                    className="barra-userPic"
                  />
                ) : (
                  <div className="barra-userPic">
                    <Skeleton circle width={50} height={50} duration={0.8} />
                  </div>
                )}
                {profileDropDown && <ProfileDropDownMenu />}
              </div>
            </ul>
          </nav>
        </div>
      ) : !search ? (
        <div className="barra-container-limit">
          <nav className="barra-container">
            <div onClick={handleNav} className="icono-menu">
              {!nav && <IoMenuSharp size={24} color="black" />}
            </div>
            <img
              src={logoBarra}
              alt="logo"
              className="img-logo"
              onClick={() => navigate("/menuestudiante")}
            />
            <IoSearch
              size={22}
              style={{ color: "black" }}
              onClick={() => setSearch(!search)}
            />
            <div
              className={
                nav ? "mobile-list-containerr" : "mobile-list-containerr-dos"
              }
            >
              <div
                className="dropdown-profile"
                style={{
                  padding: "0.5rem 0.4rem 0rem 0.8rem",
                  background: "#F7F9FA",
                }}
              >
                <img src={userData.userPic} />
                <div>
                  <h4>{userData.nombreCompleto}</h4>
                  <p>{userData.cif}</p>
                  <p>{userData.correoInstitucional}</p>
                </div>
              </div>
              <div className="mobile-list" style={{ padding: "0rem" }}>
                <div>
                  <Link to={"/misprestamos"} className="list-links-mobile">
                    <p style={{ color: "#0B545B", lineHeight: "0" }}>
                      Mis Préstamos
                    </p>
                  </Link>
                  <Link to={"/perfil"} className="list-links-mobile">
                    <p style={{ color: "#0B545B", lineHeight: "0" }}>
                      Configuración de tu cuenta
                    </p>
                  </Link>
                </div>
                <div className="mobile-list-logout" onClick={handleLogOut}>
                  <p>Cerrar Sesión</p>
                  <BiLogIn size={32} style={{ color: "red" }} />
                </div>
              </div>
            </div>
            {nav && (
              <div onClick={handleNav} className="mobile-list-closeBtn">
                <IoClose size={26} color="black" />
              </div>
            )}
          </nav>
        </div>
      ) : (
        <div className="barra-container-limit">
          <div className="barra-container" style={{ gap: "1rem" }}>
            <form className="usuarioBarra-searchContainer" onSubmit={handleSearch}>
              <AiOutlineSearch size={20} style={{ color: "#909090" }} />
              <input
                type="text"
                placeholder="Buscar un libro"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </form>
            <IoCloseCircle
              size={35}
              color="#0B545B"
              onClick={() => setSearch(!search)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function ProfileDropDownMenu() {
  const navigate = useNavigate();
  const { userData, logoutUser } = useUser();

  const handleLogOut = async () => {
    try {
      await logoutUser();
      navigate("/");
    } catch (e) {
      console.log(e.message);
    }
  };
  return (
    <div className="dropdown-menucontainer">
      <div className="dropdown-profile">
        <img src={userData.userPic} alt="logo" />
        <div>
          <h4>{userData.nombreCompleto}</h4>
          <p>{userData.cif}</p>
          <p>{userData.correoInstitucional}</p>
        </div>
      </div>
      <Link to={"/perfil"} className="perfil-link">
        Configuración de tu cuenta
      </Link>
      <div className="dropdown-logout" onClick={handleLogOut}>
        <p>Cerrar Sesión</p>
        <BiLogIn
          size={24}
          style={{ color: "#909090" }}
          className="logout-icon"
        />
      </div>
    </div>
  );
}

function MisPrestamosDropDown({ prestamosData }) {
  return (
    <div className="misPrestamosDropDown-container">
      <div className="contenido">
        {prestamosData.length > 0 ? (
          prestamosData
            .slice(0, 3)
            .map((prestamo, index) => (
              <PrestamoDropDownItem
                prestamo={prestamo}
                index={index}
                key={prestamo.idPrestamo}
              />
            ))
        ) : (
          <div
            className="prestamoDropDownItem-container"
            style={{ justifyContent: "center" }}
          >
            <p style={{ color: "gray" }}>¡Aún no has prestado ningún libro!</p>
          </div>
        )}
        <Link
          to={"/misprestamos"}
          className="misPrestamosDropDown-btnContainer"
        >
          <button className="misPrestamosDropDown-btn">
            Ir a mis Préstamos
          </button>
        </Link>
      </div>
    </div>
  );
}

function PrestamoDropDownItem({ prestamo }) {
  return (
    <div className="prestamoDropDownItem-container">
      <BookImage
        src={prestamo.libroImagen}
        alt={prestamo.libroTitulo}
        className={"prestamoDropDownItem-imagen"}
      />
      {/* <img src={prestamo.libroImagen} alt='img-libro'/> */}
      <div className="prestamoDropDownItem-Info">
        <h4>{acortarTexto(prestamo.libroTitulo, 22)}</h4>
        <p className="prestamoDropDownItem-subtitle">Fecha límite de devolución:</p>
        <p className="prestamoDropDownItem-subtitle2">
          {formatearFecha(prestamo.fechaLimiteDevolucion)}
        </p>
        <p className="prestamoDropDownItem-subtitle">Código de Retiro: </p>
        <p className="prestamoDropDownItem-subtitle2">
          {prestamo.codigoRetiro}
        </p>
      </div>
    </div>
  );
}

export default Barra;

